import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Nav,
  Button,
  Modal,
  FormCheck,
} from "react-bootstrap"
import CandidateData from "./CandidateData"
import "./Admin.css" // Import the CSS file
import {
  downloadCandidates,
  fetchAdmins,
  toggleAuthenticated,
} from "../app/functions"
import LogoutButton from "../components/LogoutButton"
import Feedback from "../components/Feedback"
import ResultModal from "../components/ResultModal"
import * as XLSX from "xlsx"

const Admin = () => {
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [selectedCandidateData, setSelectedCandidateData] = useState(null)
  const [candidates, setCandidates] = useState()
  const [showAdminModal, setShowAdminModal] = useState(false)
  const [showResultModal, setShowResultModal] = useState(false)
  const [adminProfiles, setAdminProfiles] = useState([])

  const admin_user = JSON.parse(localStorage.getItem("user"))

  useEffect(() => {
    initProgram()
  }, [])

  const initProgram = async () => {
    let download = await downloadCandidates()
    setCandidates(download)

    let admins = await fetchAdmins()
    setAdminProfiles(admins)
  }

  const handleCandidateClick = (candidate) => {
    setSelectedCandidate(candidate.uid)
    setSelectedCandidateData(candidate)
  }
  const handleClose = () => setShowAdminModal(false)
  const closeResultModal = () => setShowResultModal(false)

  const changeAuthenticatedAdmin = async (id, authenticated) => {
    let newProfiles = await toggleAuthenticated(id, authenticated)
    setAdminProfiles(newProfiles)
  }

  const exportToExcel = async () => {
    try {
      // Fetch all submissions
      const submissions = await downloadCandidates()

      if (!submissions || submissions.length === 0) {
        alert("Brak danych do eksportu")
        return
      }

      // Flatten nested objects and convert to array format
      const excelData = submissions.map((submission) => {
        const row = {}

        // Add all fields from submission
        Object.keys(submission).forEach((key) => {
          const value = submission[key]

          // Handle different data types
          if (value === null || value === undefined) {
            row[key] = ""
          } else if (
            typeof value === "object" &&
            value.constructor === Object
          ) {
            // If it's an object, convert to JSON string
            row[key] = JSON.stringify(value)
          } else if (Array.isArray(value)) {
            // If it's an array, convert to comma-separated string
            row[key] = value.join(", ")
          } else if (typeof value === "boolean") {
            // Convert boolean to readable text
            row[key] = value ? "Tak" : "Nie"
          } else if (value instanceof Date) {
            // Format dates
            row[key] = value.toLocaleDateString("pl-PL")
          } else {
            row[key] = String(value)
          }
        })

        return row
      })

      // Create workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(excelData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, "Submissions")

      // Generate filename with current date
      const date = new Date()
      const dateStr = date.toISOString().split("T")[0]
      const filename = `submissions_${dateStr}.xlsx`

      // Write file
      XLSX.writeFile(workbook, filename)
    } catch (error) {
      console.error("Error exporting to Excel:", error)
      alert("Wystąpił błąd podczas eksportu danych")
    }
  }

  return (
    <div className="admin-container">
      <Container fluid>
        <Row>
          {/* Left side: Menu with Candidate List */}
          <Col
            md={3}
            className="admin-sidebar bg-rotary p-3 rounded per90 mb-2"
            style={{
              border: "2px solid #f7a81b",
              backgroundColor: "rgba(255, 255, 255, 0.1)",
            }}
          >
            <h4 className="text-white">Kandydaci stypendialni</h4>

            <div className="admin-candidate-list">
              <Nav className="flex-column">
                {candidates?.map((candidate, index) => (
                  <Nav.Link
                    key={index}
                    className={` ${selectedCandidate === candidate.uid
                      ? "text-black"
                      : "text-white"
                      }`}
                    onClick={() => handleCandidateClick(candidate)}
                  >
                    {index + 1}. {candidate.name} {candidate.surname}
                    {candidate.scholarshipType ? (
                      <span className="candidate-scholarship-type">
                        {" "}
                        {candidate.scholarshipType.includes("Bronisławy Skup")
                          ? "Stypendium im. Bronisławy Skup"
                          : candidate.scholarshipType}
                      </span>
                    ) : null}
                    <hr />
                  </Nav.Link>
                ))}
              </Nav>
            </div>

            <div className="admin-sidebar-actions">
              <LogoutButton />
              {admin_user.superadmin === true && (
                <Button
                  onClick={() => setShowAdminModal(true)}
                  className=" mx-2"
                >
                  Administratorzy
                </Button>
              )}

              {/* Display only if superadmin */}
              {/* {
                (admin_user.superadmin === true) &&  */}
              <Button onClick={() => setShowResultModal(true)}>
                Rezultaty
              </Button>
              {/* } */}
              <Button
                onClick={exportToExcel}
                className="mt-2"
                variant="success"
                style={{ display: "block", width: "100%" }}
              >
                Eksportuj do Excel
              </Button>
            </div>
          </Col>

          {/* Right side: Candidate Data */}
          <Col md={9}>
            {selectedCandidateData ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <CandidateData
                  uid={selectedCandidate}
                  candidateData={selectedCandidateData}
                />
                <Feedback
                  uid={selectedCandidate}
                  candidateData={selectedCandidateData}
                />
              </div>
            ) : (
              <h1 className="text-white">Wybierz Kandydata z menu!</h1>
            )}
          </Col>
        </Row>
      </Container>

      <Modal show={showAdminModal} centered onHide={handleClose}>
        <Modal.Title className="justify-center flex flex-col items-center p-4 pb-0">
          <div className="mb-2">Lista administratorów</div>
          <div style={{ fontSize: 16, fontWeight: "normal" }}>
            Zaznacz użytkownika, aby nadać mu uprawnienia administratorskie.
          </div>
        </Modal.Title>
        <Modal.Body className="justify-center flex flex-col items-center p-4">
          <div className="flex flex-col gap-4">
            <div
              className="flex  items-center p-2 border-b w-full"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <strong>Email</strong>
              <strong>Uprawnienia</strong>
            </div>
            {adminProfiles?.map((user) => (
              <div
                key={user.id}
                className="flex  items-center p-2 border-b w-full"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>{user.email}</div>
                <FormCheck
                  checked={user.authenticated === true}
                  // disabled
                  type="switch"
                  onChange={() =>
                    changeAuthenticatedAdmin(user.id, user.authenticated)
                  }
                />
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
      <ResultModal
        showResultModal={showResultModal}
        handleClose={closeResultModal}
        handleCandidateClick={handleCandidateClick}
      />
    </div>
  )
}

export default Admin
